type SharedShortcutType =
	| "TAB"
	| "D"
	| "E"
	| "G"
	| "I"
	| "J"
	| "K"
	| "M"
	| "O"
	| "P"
	| "R"
	| "U"
	| "A"
	| "esc"
	| "S"
	| "L"
	| "C"
	| "T"
	| "B"
	| "F"
	| "H"
	| "N"
	| "Q"
	| "V"
	| "W"
	| "X"
	| "Y"
	| "Z"
	| "0"
	| "1"
	| "2"
	| "3"
	| "4"
	| "5"
	| "6"
	| "7"
	| "8"
	| "9"
	| "/"
	| "."
	| ","

type ShortcutSymbol =
	| "ALT"
	| "BACKSPACE"
	| "CMD"
	| "CTRL"
	| "ENTER"
	| "SHIFT"
	| SharedShortcutType

export type ShortcutValue =
	| "⌥"
	| "⌘"
	| "⏎"
	| "⇧"
	| "⌫"
	| "ctrl"
	| SharedShortcutType

export const ShortcutSymbols: Record<ShortcutSymbol, ShortcutValue> = {
	ALT: "⌥",
	CMD: "⌘",
	CTRL: "ctrl",
	ENTER: "⏎",
	SHIFT: "⇧",
	BACKSPACE: "⌫",
	TAB: "TAB",
	esc: "esc",
	A: "A",
	B: "B",
	C: "C",
	D: "D",
	E: "E",
	F: "F",
	G: "G",
	H: "H",
	I: "I",
	J: "J",
	K: "K",
	L: "L",
	M: "M",
	N: "N",
	O: "O",
	P: "P",
	Q: "Q",
	R: "R",
	S: "S",
	T: "T",
	U: "U",
	V: "V",
	W: "W",
	X: "X",
	Y: "Y",
	Z: "Z",
	"0": "0",
	"1": "1",
	"2": "2",
	"3": "3",
	"4": "4",
	"5": "5",
	"6": "6",
	"7": "7",
	"8": "8",
	"9": "9",
	"/": "/",
	".": ".",
	",": ",",
}

export type ShortcutSymbols = typeof ShortcutSymbols

// Maps a displayed shortcut glyph to the token used for live key-press tracking.
// Modifiers use logical tokens (Meta/Shift/Alt/Control) read off event flags;
// everything else uses the physical KeyboardEvent.code so it fires on any layout.
export const ShortcutValueToKeyToken: Record<ShortcutValue, string> = {
	"⌘": "Meta",
	"⇧": "Shift",
	"⌥": "Alt",
	ctrl: "Control",
	"⏎": "Enter",
	"⌫": "Backspace",
	TAB: "Tab",
	esc: "Escape",
	A: "KeyA",
	B: "KeyB",
	C: "KeyC",
	D: "KeyD",
	E: "KeyE",
	F: "KeyF",
	G: "KeyG",
	H: "KeyH",
	I: "KeyI",
	J: "KeyJ",
	K: "KeyK",
	L: "KeyL",
	M: "KeyM",
	N: "KeyN",
	O: "KeyO",
	P: "KeyP",
	Q: "KeyQ",
	R: "KeyR",
	S: "KeyS",
	T: "KeyT",
	U: "KeyU",
	V: "KeyV",
	W: "KeyW",
	X: "KeyX",
	Y: "KeyY",
	Z: "KeyZ",
	"0": "Digit0",
	"1": "Digit1",
	"2": "Digit2",
	"3": "Digit3",
	"4": "Digit4",
	"5": "Digit5",
	"6": "Digit6",
	"7": "Digit7",
	"8": "Digit8",
	"9": "Digit9",
	"/": "Slash",
	".": "Period",
	",": "Comma",
}
